import React, { useRef, useState } from "react";
import { Button, Card, Divider } from "antd";
import { ProfileTwoTone } from "@ant-design/icons";
import CheckForm from "./CheckForm";
import CheckDetailList from "./CheckDetailList";
import { useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const formRef = useRef();
    const { closeNav } = useModelDispatchers("nav");
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
    const history = useHistory();
    const onSave = () => {
        formRef.current.insert(setSaveBtnDisabled);
    }
    const onBack = () => {
        closeNav();
        goPage(history, "4-2");
    }


    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">盘库单号</span>
                </h3>
                <div style={{ width: "500px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.ST_STTAKE_AD_SAVE}>
                        <Button type="primary" onClick={onSave} disabled={saveBtnDisabled}>保存</Button>
                    </YhAuth>
                    <Button className="margin-left-8" onClick={onBack}>返回</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >

            <CheckForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT} />

            <Divider orientation="left" />

            <CheckDetailList />
        </Card>
    );
}